import { PullRequestSet } from 'src/types/pull-requests-table';
import { createReducer } from 'src/utils/create-reducer';

import { EXPAND_PULL_REQUESTS, LoadDashboardOverview } from '../actions';

export type DashboardPullRequestsState = {
  expandedPullRequestSets: PullRequestSet[];
  isLoading: boolean;
  pullRequests: {
    authored: string[];
    reviewing: string[];
    closed: string[];
  };
};

const initialState: DashboardPullRequestsState = {
  expandedPullRequestSets: [],
  isLoading: true,
  pullRequests: {
    authored: [],
    reviewing: [],
    closed: [],
  },
};

export const pullRequestsReducer = createReducer(initialState, {
  [EXPAND_PULL_REQUESTS](state, action) {
    if (state.expandedPullRequestSets.indexOf(action.payload) !== -1) {
      return state;
    }

    return {
      ...state,
      expandedPullRequestSets: [
        ...state.expandedPullRequestSets,
        action.payload,
      ],
    };
  },

  [LoadDashboardOverview.REQUEST](state) {
    return {
      ...state,
      isLoading: true,
    };
  },

  [LoadDashboardOverview.SUCCESS](state, action) {
    return {
      ...state,
      pullRequests: action.payload.result.pullRequests,
      isLoading: false,
    };
  },

  [LoadDashboardOverview.ERROR](state) {
    return {
      ...state,
      isLoading: false,
    };
  },
});
